import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SnackbarKey, useSnackbar } from 'notistack';
import { closeSnackbar as closeSnackbarAction } from '../../store/alert/actions';
import { getNotificationsSelector } from '../../store/alert/selectors';
import { INotification } from '../../store/alert/types';

const useNotifier = () => {

    const dispatch = useDispatch();
    const notifications = useSelector(getNotificationsSelector);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [displayed, setDisplayed] = useState<SnackbarKey[]>([]);

    const storeDisplayed = (id: SnackbarKey | undefined) => {
        if (id) {
            let displayedList = [...displayed, id];
            setDisplayed(displayedList);
        }
    };

    const removeDisplayed = (id: SnackbarKey | undefined) => {
        if (id) {
            let displayedList = [...displayed.filter(key => id !== key)];
            setDisplayed(displayedList);
        }
    };

    useEffect(() => {
        notifications.filter(x => x && x?.dismissed !== true).forEach(({ key, message, options = {}, dismissed = false }: INotification) => {
            
            if (dismissed) {
                // dismiss snackbar using notistack
                closeSnackbar(key);
                return;
            }

            // do nothing if snackbar is already displayed
            if (key && displayed.includes(key)) return;

            // display snackbar using notistack
            enqueueSnackbar(message, {
                key,
                ...options,
                onClose: (event, reason, myKey) => {
                    if (options.onClose) {
                        options.onClose(event, reason, myKey);
                    }
                },
                onExited: (event, myKey) => {
                    // remove this snackbar from display list - keep redux store
                    dispatch(closeSnackbarAction(myKey));
                    removeDisplayed(myKey);                    
                },
            });

            // keep track of snackbars that we've displayed
            storeDisplayed(key);
        });
    }, [notifications, closeSnackbar, enqueueSnackbar, dispatch]);
};

export default useNotifier;
